"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundColor = void 0;
/**
 * Background color names are derived from the Ameriprise Brand Center and ADEL
 * color palettes, with the "ameriprise" prefix omitted for brevity.
 *
 * Internal references:
 * https://ameriprise.sharepoint.com/sites/brandcent/SitePages/Color.aspx
 * https://digital.dev.ameriprise.com/adel/utilities/color/color.hbs?theme=amp.next
 */
var BackgroundColor;
(function (BackgroundColor) {
    // Tint group
    BackgroundColor["STONE"] = "stone";
    BackgroundColor["MINT_TINT"] = "mint-tint";
    BackgroundColor["LIME_TINT"] = "lime-tint";
    BackgroundColor["PURPLE_TINT"] = "purple-tint";
    BackgroundColor["BERRY_TINT"] = "berry-tint";
    BackgroundColor["ORANGE_TINT"] = "orange-tint";
    // Neutral
    BackgroundColor["WHITE"] = "white";
    BackgroundColor["TRANSPARENT"] = "transparent";
    BackgroundColor["NONE"] = "";
    // Dark/Hero group
    BackgroundColor["MIDNIGHT_BLUE"] = "midnight-blue";
    BackgroundColor["LIGHT_BLUE"] = "light-blue";
    BackgroundColor["AMERIPRISE_BLUE"] = "ameriprise-blue";
    BackgroundColor["PURPLE"] = "purple";
    BackgroundColor["BERRY"] = "berry";
    BackgroundColor["MINT"] = "mint";
    BackgroundColor["DARK_MINT"] = "dark-mint";
    BackgroundColor["ORANGE"] = "orange";
    BackgroundColor["DARK_GREY"] = "dark-grey";
    // Mixed/partial group
    BackgroundColor["LIME"] = "lime";
    /** @deprecated use PURPLE_TINT instead */
    BackgroundColor["PURPLE_LIGHT"] = "purple-light";
    /** @deprecated use LIME_TINT instead */
    BackgroundColor["LIME_LIGHT"] = "lime-light";
    /** @deprecated use MINT_TINT instead */
    BackgroundColor["MINT_LIGHT"] = "mint-light";
    /** @deprecated use LIME_TINT instead */
    BackgroundColor["LIGHT_LIME"] = "light-lime";
    /** @deprecated use MINT_TINT instead */
    BackgroundColor["LIGHT_MINT"] = "light-mint";
    /** @deprecated use PURPLE_TINT instead */
    BackgroundColor["LIGHT_PURPLE"] = "light-purple";
    /**
     * Facet color variants follow the naming conventions defined in the
     * Ameriprise Brand Center graphic device guidelines.
     *
     * Internal reference:
     * https://ameriprise.sharepoint.com/sites/brandcent/SitePages/Graphic-devices.aspx
     */
    BackgroundColor["WHITE_FACET"] = "white-facet";
    BackgroundColor["FADED_WHITE_FACET"] = "faded-white-facet";
    /** @deprecated use WHITE_FACET instead */
    BackgroundColor["GREY_FACET"] = "grey-facet";
    BackgroundColor["MIDNIGHT_FACET"] = "midnight-facet";
    BackgroundColor["MIDNIGHT_BLUE_FACET"] = "midnight-blue-facet";
    BackgroundColor["PURPLE_FACET"] = "purple-facet";
    BackgroundColor["DARK_MINT_FACET"] = "dark-mint-facet";
    BackgroundColor["MINT_FACET"] = "mint-facet";
    BackgroundColor["BERRY_FACET"] = "berry-facet";
    BackgroundColor["ORANGE_FACET"] = "orange-facet";
    BackgroundColor["LIGHT_BLUE_FACET"] = "light-blue-facet";
})(BackgroundColor || (exports.BackgroundColor = BackgroundColor = {}));
